module.exports = new __parcel__URL__("beetlejuice-sylvia-sidney.2d67cd67.gif").toString();